module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp123_9006.8ee99409.png";